import api from './api';

export const analyticsService = {
    // Patient Analytics
    getPatientAnalytics: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/analytics/patients?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch patient analytics');
        }
    },

    // Drug Analytics
    getDrugAnalytics: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/analytics/drugs?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch drug analytics');
        }
    },

    // Disease Statistics
    getDiseaseStatistics: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/analytics/diseases?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch disease statistics');
        }
    },

    // Test Analytics
    getTestAnalytics: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/analytics/tests?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch test analytics');
        }
    },

    // Dashboard
    getDashboard: async (period = 'month') => {
        try {
            const response = await api.get(`/analytics/dashboard?period=${period}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch dashboard');
        }
    }
};
